import { z } from 'zod';
import { ExperienceDescriptionType } from '@axiom/validation';

export const ExperienceEditWorkDetailsSchema = z.object({
  description: ExperienceDescriptionType,
});

export type WorkDetailsFormSchemaType = z.infer<
  typeof ExperienceEditWorkDetailsSchema
>;
